// extracted by mini-css-extract-plugin
export var actuItem = "notifications-module--actu-item--3a931";
export var notifItem = "notifications-module--notif-item--89a9a";
export var notificationCategorie = "notifications-module--notification-categorie--9e342";
export var notificationDate = "notifications-module--notification-date--dbc33";
export var notificationInfos = "notifications-module--notification-infos--28b5d";
export var notificationResume = "notifications-module--notification-resume--5be32";
export var notificationTitle = "notifications-module--notification-title--2bc43";
export var notifsItemsContainer = "notifications-module--notifs-items-container--26314";